// Component Name: ResearchPublications
// Description: Section displaying a list of research publications with images alternating sides, styled as colored cards.
import React from 'react';
import styles from './ResearchPublications.module.css'; // CSS Modules for maintainability
function ResearchPublications() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };
  return (
    <section className={styles.rpSection}>
      <h2 className={styles.rpTitle}>Research &amp; Publications</h2>
      <div className={styles.rpIntro}>
        <span className={styles.rpBullet} aria-hidden="true">&#8226;</span>
        <span>
          Dr. Shruti Sagar is an active researcher with numerous publications in prestigious medical journals:
        </span>
      </div>
      {/* Card 1: Image right */}
      <div className={`${styles.rpCard} ${styles.rpCardBlue} ${styles.rpRow}`}>
        <img
          src="https://i.ibb.co/qMRgq1dP/image-11-3.png"
          alt="Endoscopy Journal Cover - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
          "Bidirectional Endoscopy - A Trend for Future in COVID Era" – Journal of Digestive Endoscopy (2022)
        </div>
      </div>
      {/* Card 2: Image left */}
      <div className={`${styles.rpCard} ${styles.rpCardLavender} ${styles.rpRowReverse}`}>
        <img
          src="https://i.ibb.co/JwGQX9Vd/image-13-1.png"
          alt="Current Diagnosis Journal Cover- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
          "Acute Obstructive Suppurative Pancreatic Ductitis Secondary to Intraductal Stones" – Gastroenterol Hepatol Endosc Pract (2021)
        </div>
      </div>
      {/* Card 3: Image right */}
      <div className={`${styles.rpCard} ${styles.rpCardBlue} ${styles.rpRow}`}>
        <img
          src="https://i.ibb.co/7NdwFy3N/image-14-1.png"
          alt="Digestive Endoscopy Journal Cover - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
          "Fluoroscopy-Assisted Percutaneous Endoscopic Gastrostomy (f-PEG)" – Journal of Digestive Endoscopy (2020)
        </div>
      </div>
      <div className={`${styles.rpCard} ${styles.rpCardLavender} ${styles.rpRowReverse}`}>
        <img
          src="https://i.ibb.co/JwGQX9Vd/image-13-1.png"
          alt="Current Diagnosis Journal Cover - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
Urinary Neutrophil Gelatinase Associated Lipocalin as an early marker of Contrast Induced Nephropathy
        </div>
      </div>
<div className={`${styles.rpCard} ${styles.rpCardBlue} ${styles.rpRow}`}>
        <img
          src="https://i.ibb.co/7NdwFy3N/image-14-1.png"
          alt="Digestive Endoscopy Journal Cover - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
Case Report: Progressive Liver Disease With
Hypercalcemia Due To Hepatic Sarcoidosis        
        </div>
      </div>
       <div className={`${styles.rpCard} ${styles.rpCardLavender} ${styles.rpRowReverse}`}>
        <img
          src="https://i.ibb.co/JwGQX9Vd/image-13-1.png"
          alt="Current Diagnosis Journal Cover - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className={styles.rpCardImage}
        />
        <div className={styles.rpCardText}>
Case Report: Pyoderma Gangrenosum in IBD Treated with Tofacitinib Ravi Shankar Bagepally
        </div>
      </div>
    </section>
  );
}
export default ResearchPublications;